import React, { useEffect, useState } from "react";
import { useI18n } from "../i18n";

const STORAGE_KEY = "saverondelio_cookie_consent_v1";

function applyConsent(state) {
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("consent", "update", {
    ad_storage: state.marketing ? "granted" : "denied",
    ad_user_data: state.marketing ? "granted" : "denied",
    ad_personalization: state.marketing ? "granted" : "denied",
    analytics_storage: state.analytics ? "granted" : "denied",
    functionality_storage: "granted",
    security_storage: "granted",
    personalization_storage: state.marketing ? "granted" : "denied",
  });
}

export default function CookieBanner() {
  const { t, lang, buildPath } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        setVisible(true);
      } else {
        const state = JSON.parse(stored);
        applyConsent(state);
      }
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const persist = (state) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) { /* ignore */ }
    applyConsent(state);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 left-0 right-0 z-50 border-t-2 border-[#006837] bg-white shadow-2xl"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col lg:flex-row lg:items-center gap-4">
        <div className="flex-1">
          <h3 className="font-heading text-lg font-bold text-[#0B2545]" data-testid="cookie-banner-title">
            {t("cookies.title")}
          </h3>
          <p className="text-sm text-slate-600 mt-1 leading-relaxed">
            {t("cookies.body")}{" "}
            <a
              href={buildPath("cookies")}
              className="text-[#006837] font-semibold underline underline-offset-2 hover:text-[#004B28]"
              data-testid="cookie-banner-readmore"
            >
              {t("cookies.readMore")}
            </a>
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 shrink-0">
          <button
            type="button"
            onClick={() => persist({ analytics: false, marketing: false })}
            data-testid="cookie-reject-button"
            className="px-5 py-3 text-sm font-semibold rounded-md border border-slate-300 text-[#0B2545] bg-white hover:bg-slate-50"
          >
            {t("cookies.reject")}
          </button>
          <button
            type="button"
            onClick={() => persist({ analytics: true, marketing: true })}
            data-testid="cookie-accept-button"
            className="px-5 py-3 text-sm font-semibold rounded-md bg-[#006837] text-white hover:bg-[#004B28]"
          >
            {t("cookies.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
